import axios from "axios";
import { baseURL } from "../config";

// Create axios instance with base configuration
const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
});

// Request interceptor to add authorization token
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('token');
    
    // If token exists, add it to the headers
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log('Session expired or unauthorized access. Redirecting to login...');
      
      // Clear localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      
      // Redirect to the login page of whichever UI the user is currently in — a session
      // expiring inside /v1 shouldn't dump them into the old UI's login.
      window.location.href = window.location.pathname.startsWith('/v1')
        ? '/v1/signin'
        : '/signin';
    }
    
    // Pass the error along
    return Promise.reject(error);
  }
);

export default axiosInstance;